module.exports = __webpack_public_path__ + "img/stick_nature_volcans_auvergne.be178e51.svg";